var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 7a1 1 0 000 4A1 1 0 002 7ZM9 7a1 1 0 000 4A1 1 0 009 7Zm7 0a1 1 0 000 4 1 1 0 000-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEtc);
export default __webpack_public_path__ + "static/media/icon--etc.9346849123e61314ef4f8b478c3ba431.svg";
export { ForwardRef as ReactComponent };